import { useEffect } from "react";

export default function ThankYou() {
  useEffect(() => {
    document.title = "Thank You | Djinni";
  }, []);

  return (
    <main style={{ padding: "3rem 1.5rem", textAlign: "center" }}>
      <h1>Thank you!</h1>
      <p>Your quote request has been received.</p>
      <p>
        We&apos;ll contact you as soon as possible, usually within a few hours.
      </p>
    </main>
  );
}
